import {
  Copy,
  Flex,
  Stack,
  SvgExclamation,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { AvailableOrderTypes } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';

export interface AvailableOrderTypesCheckboxProps {
  name: string;
  id: string;
  hasGroupOption: boolean;
}

export function AvailableOrderTypesCheckbox({
  name,
  id,
  hasGroupOption,
}: AvailableOrderTypesCheckboxProps): JSX.Element {
  const { register, errors } = useFormContext();

  const orderTypeValues = Object.values(AvailableOrderTypes).filter(
    (value) => hasGroupOption || value !== AvailableOrderTypes.GROUP
  );

  return (
    <>
      <Stack y="xxx-sm">
        <Copy variant="body" color="secondaryText">
          Order types
        </Copy>
      </Stack>
      <Flex alignItems="center">
        {orderTypeValues.map((value) => (
          <Stack x="lg" key={value}>
            <Flex>
              <Checkbox
                cancelLabelBottomMargin
                id={`${id}${value}`}
                name={name}
                label={value}
                ref={register({
                  validate: (value: AvailableOrderTypes[]) => {
                    return value && value.length > 0;
                  },
                })}
                value={value}
              />
            </Flex>
          </Stack>
        ))}
        {errors[name] && (
          <Copy variant="body" color="warning">
            <Stack as="span" x="xxx-sm">
              <SvgExclamation size="20px" />
            </Stack>
            Select your option
          </Copy>
        )}
      </Flex>
    </>
  );
}
